export const APP_ROUTES = {
  HOME: "/",
  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  HKI_ANIMATICA: "/hki-animatica",
  ENTERTAINMENT: "/entertainment",
  COURSES: "/courses",
  SERVICES: "/services",
  MEDIA_SERVICES: {
    GET_MEDIA_SERVICES: "/media-services",
    VIEW_SERVICE: (serviceSlug = ":serviceSlug") => `/media-services/${serviceSlug}`,
  },
  MEDIA_MATRIX_APP: "/media-matrix-app",
  EVENT_PLAN: "/event/plan",
  AR_VR: "/ar-vr",
  GIGMATIC_STUDIOS: "/gigmatic-studios",
  CORPORATE: "/corporate",
  FRANCHISE: "/franchise",
  OUR_WORK: "/our-work",
  EVENTS_EXPERIENCES: "/events-experiences",
  INFLUENCER_MARKETING: "/influencer-marketing",
  CELEBRITY_MARKETING: "/celebrity-marketing",
  AI_CONTENT_CREATION: "/ai-content-creation",
  NEWS: "/news",
  BLOGS: {
    GET_BLOGS: "/blogs",
    VIEW_BLOG_POST: (slug = ":slug") => `/blogs/${slug}`,
  },
  MOVIE_LINKS: {
    GET_MOVIE_LINKS: "/movie-links",
    VIEW_MOVIE_LINKS_WITH_REFERRAL: (referralCode = ":referralCode") =>
      `/movie-links/${referralCode}`,
  },
  PRIVACY_POLICY: "/privacy-policy",
  CATCH_ALL: "*",
};
